module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('SgsRenderNotificationSuccess', {
    model: {
      value: (_vm.notificationSuccess),
      callback: function($$v) {
        _vm.notificationSuccess = $$v
      },
      expression: "notificationSuccess"
    }
  }), _vm._v(" "), _c('SgsRenderNotificationError', {
    model: {
      value: (_vm.notificationError),
      callback: function($$v) {
        _vm.notificationError = $$v
      },
      expression: "notificationError"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c(_vm.currentView, {
    tag: "component",
    attrs: {
      "params": _vm.params
    },
    on: {
      "callBusinessRule": _vm.callBusinessRule,
      "actionLinkSelected": _vm.actionLinkSelected
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4799f4cd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/module/components/ModuleCustom.vue
// module id = 921
// module chunks = 2